<template>
    <div id="home">
        <div class="home1">
            <div class="homebox">
                <el-carousel  class="carouselbox" :height="screenwidth">
                    <el-carousel-item v-for="(item,index) in banner2.images" :key="index">
                        <img :src="url+item" alt="" @click="jumpbannerpage(banner2.url,index)">
                    </el-carousel-item>
                </el-carousel>
                <img :src="url+banner.images[0]" alt="" class="hom1img2" @click="jumpbannerpage(banner.url,0)">
            </div>
           
            <img :src="url+banner.images[1]" alt="" @click="jumpbannerpage(banner.url,1)">
            <div class="poimgBox">
                <img  v-for="(item,index) in banner3.images" :key="index" :src="url+item" alt="" class="hom1img1" @click="jumpbannerpage(banner3.url,index)">
            </div>
        </div>
        <div class="home2">
            <p class="title" v-html="titlelist[0].title"></p>
            <p class="subtitle"  v-html="titlelist[0].subtitle"></p>
            <ul>
                <li v-for="(item,index) in home2" :key="index" @mouseover="changeHome2Index=index" class="wow animate__animated animate__fadeInUp">
                    <div class="on" v-show="index==changeHome2Index">
                        <img src="@/assets/home/home2Bg.png" alt="" class="bg">
                        <div>
                            <p class="p1"><img :src="url+item.avatar" alt="" class="icon">{{item.title}}</p>
                            <p class="p2">{{item.subtitle}}</p>
                            <button @click="submit(false)">免费试用</button>
                        </div>
                    </div>
                    <div class="notOn" v-show="index!=changeHome2Index">
                        <img :src="url+item.image" alt="" class="icon"> 
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                    </div>
                </li>
            </ul>
        </div>

        <div class="home3">
            <p class="title" v-html="titlelist[1].title"></p>
            <p class="subtitle" v-html="titlelist[1].subtitle"></p>
            <ul class="home3_1">
                <li v-for="(item,index) in home3.home3_1" :key="index"  @mouseover="changeHome3Index1=index" :class="[changeHome3Index1==index?'on':'','wow','animate__animated','animate__fadeInUp']">
                    {{item.title}}
                    <img src="@/assets/home/home3_1.png" alt="" v-show="changeHome3Index1!=index">
                    <img src="@/assets/home/home3_1_on.png" alt="" v-show="changeHome3Index1==index">
                </li>
            </ul>
            <div class="home3_2">
                <ul class="home3_2_left">
                    <li  v-for="(item,index) in home3.home3_2" :key="index"  @mouseover="changeHome3Index2=index" class="wow animate__animated animate__fadeInUp">
                        <p class="tip1" v-show="changeHome3Index2==index">{{item.title}}</p>
                        <p class="tip2" v-show="changeHome3Index2!=index">{{item.title}}</p>
                        <p class="p1">{{item.subtitle}}</p>
                        <p class="p2" v-html="item.content"></p>
                    </li>
                </ul>
                <div class="home3_2_right">
                    <img :src="url+home3.home3_2[changeHome3Index2].image" alt="">
                    <div>
                        <button class="button1" @click="submit(false)">免费试用</button>
                        <button class="button2" @click="submit(true)">立即咨询</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="home4">
            <p class="title" v-html="titlelist[2].title"></p>
            <p class="subtitle" v-html="titlelist[2].subtitle"></p>
            <div class="home_4_box">
                <ul class="home4_left">
                    <li  v-for="(item,index) in home4" :key="index"  @mouseover="changeHome4Index=index"  class="wow animate__animated animate__fadeInUp">
                        <p class="tip1" v-show="changeHome4Index==index">{{item.title}}</p>
                        <p class="tip2" v-show="changeHome4Index!=index">{{item.title}}</p>
                        <p class="p1">{{item.subtitle}}</p>
                        <p class="p2" v-html="item.content"></p>
                    </li>
                </ul>
                <div class="home4_right">
                    <img :src="url+home4[changeHome4Index].image" alt="">
                </div>
            </div>
        </div>

        <div class="home5">
            <p class="title" v-html="titlelist[3].title"></p>
            <p class="subtitle" v-html="titlelist[3].title"></p>
            <ul>
                <li v-for="(item,index) in home5" :key="index" v-show="index<4" v-html="item.title"></li>
            </ul>
        </div>
        <div class="home6">
            <img :src="url+home5[5].image" alt="">
        </div>

        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
    </div>
</template>

<script>
import mydialog from '@/components/dialog/dialog.vue'
import { rotationmap,home } from '@/api/api'
export default {
    name:"home",
    components: {
        mydialog
    },
    data(){
        return {
            showtc2:false,
            tcshow:true,
            url : window.url,
            banner: {}, 
            banner2:{},
            banner3:{},
            changeHome2Index:0,
            home2:[

            ],
            changeHome3Index1:0,
            changeHome3Index2:0,
            home3:{
                home3_1:[],
                home3_2:[
                    
                ]
            },
            changeHome4Index:0,
            home4:[],
            home5:[],
            titlelist:[],
            screenwidth:0,
        }
    },
    mounted(){
        var that = this
        //初始化动画
        this.$nextTick(()=>{
            this.$wow.init()
        })
        rotationmap({'type':0}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
        })
        rotationmap({'type':9}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner2 = response.data.data[0]
        })
        rotationmap({'type':10}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner3 = response.data.data[0]
        })
        home().then((response) => {
            this.titlelist = response.data.data[0]
            this.home2 = response.data.data[1]
            this.home3.home3_1 = response.data.data[2]
            this.home3.home3_2 = response.data.data[5]
            this.home4 = response.data.data[3]
            this.home5 = response.data.data[4]
        })
        if(document.documentElement.clientWidth>750){
            this.screenwidth =(document.documentElement.clientWidth * 668) / 1620 + "px";
        }else{
            this.screenwidth  = 168+"px";
        }
        
        window.onresize = () => {
            return (() => {
                if (document.documentElement.clientWidth > 750) {
                    this.screenwidth =(document.documentElement.clientWidth * 668) / 1620 + "px";
                }
            })();
        };
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e,y){
            this.showtc2 = true
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
    :root {
        --web-title-fontsize: 30px;
        --web-subtitle-fontsize: 22px;
        --web-text-fontsize: 16px;
    } 
    @media (min-width:750px) {
        #home{
            .home1{
                position: relative;
                .carouselbox{
                    // height: 640px;
                    .el-carousel__container{
                        height: 100%;
                    }
                }
                .homebox{
                    position: relative;
                    .hom1img2{
                        z-index: 3;
                        position: absolute;
                        bottom: -150px;
                    }
                }
                img{
                    width: 100%;
                }
                
                .poimgBox{
                    width: 700px;
                    position: absolute;
                    bottom: 300px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    justify-content: space-between;
                    img{
                        height: 160px;
                        width: auto;
                        cursor: pointer;
                    }
                }
            }
            .home2{
                width: 1300px;
                margin:106px auto 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: 400;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 22px;
                    span{
                        color: #558AFF;
                        font-weight: 600;
                    }
                }
                .subtitle{
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 90px;
                    li{
                        width: 240px;
                        height: 220px;
                        .on{
                            height: 100%;
                            background: #FFFFFF;
                            box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.11);
                            border-radius: 10px 60px 10px 10px;
                            position: relative;
                            .bg{
                                width: 100%;
                                height: 100%;
                            }
                            div{
                                padding: 20px;
                                position: absolute;
                                width: 100%;
                                height: 100%;
                                top: 0;
                                left: 0;
                                .icon{
                                    width: 64px;
                                }
                                .p1{
                                    display: flex;
                                    align-items: flex-end;
                                    font-size: var(--web-subtitle-fontsize);
                                    font-weight: 400;
                                    color: #FFFFFF;
                                    margin-bottom: 8px;
                                }
                                .p2{
                                    font-size: var(--web-text-fontsize);
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                                button{
                                    width: 157px;
                                    height: 40px;
                                    background: #FFFFFF;
                                    border-radius: 61px 61px 61px 61px;
                                    font-size: 19px;
                                    font-weight: 500;
                                    color: #558AFF;
                                    display: block;
                                    margin: 14px auto 0;
                                    cursor: pointer;
                                }
                            }
                        }
                        .notOn{
                            height: 100%;
                            background: #FFFFFF;
                            box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.11);
                            border-radius: 10px 60px 10px 10px;
                            padding: 20px;
                            .icon{
                                width: 64px;
                            }
                            .p1{
                                font-size: var(--web-subtitle-fontsize);
                                font-weight: 400;
                                color: #120851;
                                margin: 8px 0 8px;
                            }
                            .p2{
                                font-size: var(--web-text-fontsize);
                                font-weight: 400;
                                color: #A3A3A3;
                            }
                        }
                    }
                }
            }
            .home3{
                width: 1300px;
                margin:106px auto 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: bold;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 22px;
                }
                .subtitle{
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                    span{
                        color: #558AFF;
                        font-weight: 600;
                    }
                }
                .home3_1{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 75px;
                    margin-bottom: 126px;
                    li{
                        width: 238px;
                        height: 76px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #355EFC;
                        cursor: pointer;
                        img{
                            width: 8px;
                            margin-left: 10px;
                        }
                    }
                    .on{
                        background: #355EFC;
                        border-radius: 61px 61px 61px 61px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #FFFFFF;
                    }
                }
                .home3_2{
                    display: flex;
                    justify-content: space-between;
                    .home3_2_left{
                        .tip1{
                            width: 126px;
                            height: 36px;
                            background: #355EFC;
                            border-radius: 10px 61px 61px 61px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 20px;
                            font-weight: 500;
                            color: #FFFFFF;
                        }
                        .tip2{
                            width: 126px;
                            height: 36px;
                            background: #E1EEFF;
                            border-radius: 10px 61px 61px 61px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 20px;
                            font-weight: 500;
                            color: #355EFC;
                        }
                        .p1{
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: 500;
                            color: #355EFC;
                            margin-top: 11px;
                        }
                        .p2{
                            font-size: var(--web-text-fontsize);
                            font-weight: 500;
                            color: #AFAFAF;
                            margin-top: 14px;
                        }
                        li:nth-child(-n+3){
                            margin-bottom: 34px;
                        }
                    }
                    .home3_2_right{
                        img{
                            width: 673px;
                        }
                        div{
                            display: flex;
                            justify-content: center;
                            margin-top: 70px;
                            .button1{
                                width: 238px;
                                height: 76px;
                                background: #355EFC;
                                border-radius: 61px 61px 61px 61px;
                                font-size: 28px;
                                font-weight: 500;
                                color: #FFFFFF;
                                margin-right: 56px;
                                cursor: pointer;
                            }
                            .button2{
                                width: 238px;
                                height: 76px;
                                border-radius: 61px 61px 61px 61px;
                                opacity: 1;
                                border: 1px solid #355EFC;
                                font-size: 28px;
                                font-weight: 500;
                                color: #355EFC;
                                background-color: #fff;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .home4{
                width: 1300px;
                margin:106px auto 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: bold;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 22px;
                }
                .subtitle{
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                    span{
                        color: #558AFF;
                        font-weight: 600;
                    }
                }
                .home_4_box{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 100px;
                    .home4_left{
                        .tip1{
                            width: 211px;
                            height: 36px;
                            background: #355EFC;
                            border-radius: 10px 61px 61px 61px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 20px;
                            font-weight: 500;
                            color: #FFFFFF;
                        }
                        .tip2{
                            width: 211px;
                            height: 36px;
                            background: #E1EEFF;
                            border-radius: 10px 61px 61px 61px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 20px;
                            font-weight: 500;
                            color: #355EFC;
                        }
                        .p1{
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: 500;
                            color: #355EFC;
                            margin-top: 11px;
                        }
                        .p2{
                            font-size: var(--web-text-fontsize);
                            font-weight: 500;
                            color: #AFAFAF;
                            margin-top: 14px;
                        }
                        li:nth-child(-n+3){
                            margin-bottom: 34px;
                        }
                    }
                    .home4_right{
                        img{
                            width: 673px;
                        }
                        div{
                            display: flex;
                            justify-content: center;
                            margin-top: 70px;
                            .button1{
                                width: 238px;
                                height: 76px;
                                background: #355EFC;
                                border-radius: 61px 61px 61px 61px;
                                font-size: 28px;
                                font-weight: 500;
                                color: #FFFFFF;
                                margin-right: 56px;
                            }
                            .button2{
                                width: 238px;
                                height: 76px;
                                border-radius: 61px 61px 61px 61px;
                                opacity: 1;
                                border: 1px solid #355EFC;
                                font-size: 28px;
                                font-weight: 500;
                                color: #355EFC;
                                background-color: #fff;
                            }
                        }
                    }
                }
            }
            .home5{
                margin:40px auto 0;
                background-color: #FAFAFA;
                padding: 50px 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: bold;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 22px;
                }
                .subtitle{
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                }
                ul{
                    width: 1300px;
                    margin:0 auto;
                    display: flex;
                    justify-content: space-between;
                    font-size: var(--web-text-fontsize);
                    font-weight: 400;
                    color: #BCBCBC;
                    margin-top: 30px;
                    span{
                        color: #355EFC;
                    }
                }
            }
            .home6{
                img{
                    width: 1300px;
                    display: block;
                    margin:40px auto 10px;
                }
            }
        }
    }
    @media screen and (max-width:750px) {
         #home{
            .home1{
                position: relative;
                .carouselbox{
                    .el-carousel__container{
                        height: 100%;
                    }
                }
                img{
                    width: 100%;
                }
                .hom1img2{
                    margin-top: -10%;
                    margin-bottom: -10%;
                    z-index: 3;
                     position: relative;
                }
                .poimgBox{
                    width: 60%;
                    position: absolute;
                    bottom: 100px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    justify-content: space-between;
                    img{
                        height: 60px;
                        width: auto;
                        cursor: pointer;
                    }
                }
            }
            .home2{
                width: 100%;
                margin:1.25rem auto 0;
                padding: 0 0.625rem;
                .title{
                    font-size: 1.25rem;
                    font-weight: 400;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 1.375rem;
                    span{
                        color: #558AFF;
                        font-weight: 600;
                    }
                }
                .subtitle{
                    font-size: 1.125rem;
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 1.25rem;
                    flex-wrap: wrap;
                    li{
                        margin-top: 0.625rem;
                        flex:0 0 45%;
                        height: 10.625rem;
                        .on{
                            height: 100%;
                            background: #FFFFFF;
                            box-shadow: 0rem 0rem 0.75rem 0.0625rem rgba(0,0,0,0.11);
                            border-radius: 0.625rem 3.75rem 0.625rem 0.625rem;
                            position: relative;
                            .bg{
                                width: 100%;
                                height: 100%;
                            }
                            div{
                                padding: 0.625rem;
                                position: absolute;
                                width: 100%;
                                height: 100%;
                                top: 0;
                                left: 0;
                                .icon{
                                    width: 2rem;
                                    margin-right: 0.625rem;
                                }
                                .p1{
                                    display: flex;
                                    align-items: flex-end;
                                    font-size: 1rem;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                    margin-bottom: 0.5rem;
                                }
                                .p2{
                                    font-size: 0.875rem;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                                button{
                                    width: 90%;
                                    height: 1.25rem;
                                    background: #FFFFFF;
                                    border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                                    font-size: 1rem;
                                    font-weight: 500;
                                    color: #558AFF;
                                    display: block;
                                    margin: 0.875rem auto 0;
                                    cursor: pointer;
                                }
                            }
                        }
                        .notOn{
                            height: 100%;
                            background: #FFFFFF;
                            box-shadow: 0rem 0rem 0.75rem 0.0625rem rgba(0,0,0,0.11);
                            border-radius: 0.625rem 3.75rem 0.625rem 0.625rem;
                            padding: 0.625rem;
                            .icon{
                                width: 1.875rem;
                            }
                            .p1{
                                font-size: 1rem;
                                font-weight: 400;
                                color: #120851;
                                margin: 0.5rem 0 0.5rem;
                            }
                            .p2{
                                font-size: 0.875rem;
                                font-weight: 400;
                                color: #A3A3A3;
                            }
                        }
                    }
                }
            }
            .home3{
                width: 100%;
                margin:1.25rem auto 0;
                padding: 0 0.625rem;
                .title{
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 1.375rem;
                }
                .subtitle{
                    font-size: 1.125rem;
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                    span{
                        color: #558AFF;
                        font-weight: 600;
                        font-size: 1.25rem;
                    }
                }
                .home3_1{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 1.25rem;
                    margin-bottom: 2.25rem;
                    flex-wrap: wrap;
                    li{
                        flex: 0 0 20%;
                        height: 1.25rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 0.625rem;
                        font-weight: 500;
                        color: #355EFC;
                        cursor: pointer;
                        img{
                            width: 0.25rem;
                            margin-left: 0.25rem;
                        }
                    }
                    .on{
                        background: #355EFC;
                        border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                        font-size: 0.75rem;
                        font-weight: 500;
                        color: #FFFFFF;
                    }
                }
                .home3_2{
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    .home3_2_left{
                        flex-wrap: 90%;
                        .tip1{
                            width: 7.875rem;
                            height: 2.25rem;
                            background: #355EFC;
                            border-radius: 0.625rem 3.8125rem 3.8125rem 3.8125rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #FFFFFF;
                        }
                        .tip2{
                            width: 7.875rem;
                            height: 2.25rem;
                            background: #E1EEFF;
                            border-radius: 0.625rem 3.8125rem 3.8125rem 3.8125rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #355EFC;
                        }
                        .p1{
                            font-size: 1.875rem;
                            font-weight: 500;
                            color: #355EFC;
                            margin-top: 0.6875rem;
                        }
                        .p2{
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #AFAFAF;
                            margin-top: 0.875rem;
                        }
                        li:nth-child(-n+3){
                            margin-bottom: 2.125rem;
                        }
                    }
                    .home3_2_right{
                        flex: 0 0 90%;
                        img{
                            width: 100%;
                            margin-top: 1.25rem;
                        }
                        div{
                            display: flex;
                            justify-content: center;
                            margin-top: 4.375rem;
                            .button1{
                                width: 100%;
                                height: 2rem;
                                background: #355EFC;
                                border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                                font-size: 1rem;
                                font-weight: 500;
                                color: #FFFFFF;
                                margin-right: 3.5rem;
                            }
                            .button2{
                                width: 100%;
                                height: 2rem;
                                border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                                opacity: 1;
                                border: 1px solid #355EFC;
                                font-size: 1rem;
                                font-weight: 500;
                                color: #355EFC;
                                background-color: #fff;
                            }
                        }
                    }
                }
            }
            .home4{
                width: 100%;
                margin:1.25rem auto 0;
                .title{
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 1.375rem;
                }
                .subtitle{
                    font-size: 1.125rem;
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                    span{
                        color: #558AFF;
                        font-weight: 600;
                        font-size: 1.25rem;
                    }
                }
                .home_4_box{
                    display: flex;
                    justify-content: center;
                    margin-top: 1.25rem;
                    flex-wrap: wrap;
                    .home4_left{
                        flex:0 0 90%;
                        .tip1{
                            width: 13.1875rem;
                            height: 2.25rem;
                            background: #355EFC;
                            border-radius: 0.625rem 3.8125rem 3.8125rem 3.8125rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #FFFFFF;
                        }
                        .tip2{
                            width: 13.1875rem;
                            height: 2.25rem;
                            background: #E1EEFF;
                            border-radius: 0.625rem 3.8125rem 3.8125rem 3.8125rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #355EFC;
                        }
                        .p1{
                            font-size: 1.875rem;
                            font-weight: 500;
                            color: #355EFC;
                            margin-top: 0.6875rem;
                        }
                        .p2{
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #AFAFAF;
                            margin-top: 0.875rem;
                        }
                        li:nth-child(-n+3){
                            margin-bottom: 2.125rem;
                        }
                    }
                    .home4_right{
                        flex:0 0 90%;
                        img{
                            width: 100%;
                            margin-top: 1.25rem;
                        }
                        div{
                            display: flex;
                            justify-content: center;
                            margin-top: 4.375rem;
                            .button1{
                                width: 14.875rem;
                                height: 4.75rem;
                                background: #355EFC;
                                border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                                font-size: 1.75rem;
                                font-weight: 500;
                                color: #FFFFFF;
                                margin-right: 3.5rem;
                            }
                            .button2{
                                width: 14.875rem;
                                height: 4.75rem;
                                border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                                opacity: 1;
                                border: 1px solid #355EFC;
                                font-size: 1.75rem;
                                font-weight: 500;
                                color: #355EFC;
                                background-color: #fff;
                            }
                        }
                    }
                }
            }
            .home5{
                margin:2.5rem auto 0;
                background-color: #FAFAFA;
                padding: 1.25rem 0;
                .title{
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #111111;
                    text-align: center;
                    margin-bottom: 1.375rem;
                }
                .subtitle{
                    font-size: 1.125rem;
                    font-weight: 400;
                    color: #BCBCBC;
                    text-align: center;
                }
                ul{
                    width: 90%;
                    margin:0 auto;
                    display: flex;
                    justify-content: space-between;
                    font-size: 0.75rem;
                    font-weight: 400;
                    color: #BCBCBC;
                    margin-top: 0.625rem;
                    flex-wrap: wrap;
                    li{
                        flex:0 0 33.3%;
                    }
                    span{
                        color: #355EFC;
                    }
                }
            }
            .home6{
                img{
                    width: 100%;
                    display: block;
                    margin:2.5rem auto 0.625rem;
                }
            }
        }
 
    }
</style>